/**
 * The lifecycle chip (ZOY-229 / ZOY-231): Guest = bookable identity with an
 * incomplete registration (no file number); Patient = registered record,
 * shown WITH its file number; merged = absorbed into another record.
 */

import { useIntl } from 'react-intl';
import { Chip } from '@/ui/kit';
import type { RegistrationState } from '@/core/clinic/patientsApi';

export function RegistrationChip(props: {
  state: RegistrationState;
  recordNumber: number | null;
  compact?: boolean;
}) {
  const intl = useIntl();
  const t = (id: string, v?: Record<string, string | number>) => intl.formatMessage({ id }, v);
  if (props.state === 'merged') return <Chip kind="quiet">{t('pt.stateMerged')}</Chip>;
  if (props.state === 'guest')
    return <Chip kind="warn">{t(props.compact ? 'pt.stateGuestShort' : 'pt.stateGuest')}</Chip>;
  return (
    <Chip kind="ok">
      {props.recordNumber !== null
        ? t('pt.statePatientNo', {
            n: intl.formatNumber(props.recordNumber, { useGrouping: false }),
          })
        : t('pt.statePatient')}
    </Chip>
  );
}
